import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable, EventEmitter} from '@angular/core';
import {TokenStorageService} from './token-storage.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

const API = `${environment.api}/api/associations`;
@Injectable({
  providedIn: 'root'
})
export class AssociationsService {
  constructor(private http: HttpClient, private tokenStorage: TokenStorageService) { }

  getAssos(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept': '*/*'
      })
    };
    return this.http.get(API, httpOptions);
  }
  getOne(slug: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept': '*/*'
      })
    };
    return this.http.get(API + '/get/' + slug, httpOptions);
  }
}
